import request from '@/utils/request'
const BASE_URL = '/AtSetting'

//系统
export default {
    list(weekStartDate) {
        return request({
            url: BASE_URL + '/GetList',
            method: 'get',
            params: { weekStartDate }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/SaveList',
            method: 'post',
            data
        })
    },
    getListByDate(date) {
        return request({
            url: BASE_URL + '/GetListByDate',
            method: 'get',
            params: { date }
        })
    },
}